// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/prop-types */
import React from 'react';
import { graphql } from 'gatsby';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { GLULayout } from '../../layouts/glu';
import PageSection from '../../components/glu/organisms/page-section';
import SessionCardContainer from '../../components/glu/organisms/session-card-container';
import { CardContainer } from '../../components/glu/organisms/course-container';
import { Head } from '../../components/templates/head';
import {
	getOrganizationSeoSchema,
	getBreadcrumbsSeoSchema,
	getImageSeoSchema,
} from '../../utils/seo-schema';
import { pageTypes } from '../../utils/url-helpers';
import { BannerNav } from '../../components/glu/organisms/banner-nav';

const WebinarLibrary = ({ data, location }) => {
	const { liveWebinarSessions, locale } = data.datoCmsGluWebinarsPage;
	const courseData = data.allDatoCmsGluCourse;
	const metaContent = {
		noIndex: data.datoCmsGluWebinarsPage.noIndex,
		noFollow: data.datoCmsGluWebinarsPage.noFollow,
		metaInformation: data.datoCmsGluWebinarsPage.seoMeta,
		fallbackTitle: data.datoCmsGluWebinarsPage.eLearningTitle,
		fallbackDescription: '',
		canonicalUrl:
			data.datoCmsGluWebinarsPage?.canonicalUrl || location?.href,
	};

	const seoSchemas = {
		organization: getOrganizationSeoSchema({ data, url: location?.origin }),
		breadcrumbs: getBreadcrumbsSeoSchema({
			pageType: pageTypes.gluWebinarsPage,
			location,
		}),
		image: getImageSeoSchema(data?.headingImage?.url),
	};
	const bannerTitle = 'Love it, Share it';
	return (
		<GoogleReCaptchaProvider
			reCaptchaKey={process.env.GATSBY_RECAPTCHA_KEY}
		>
			<Head metaContent={metaContent} seoSchemas={seoSchemas} />
			{bannerTitle && <BannerNav title={bannerTitle} />}
			<PageSection theme="White">
				<h1 className="mb-10 text-3xl lg:text-5xl">
					Upcoming live webinar sessions
				</h1>
				<SessionCardContainer
					liveWebinarSessions={liveWebinarSessions}
					locale={locale}
				/>
				<CardContainer
					cardContainerContent={{
						id: 'course-container',
					}}
					cardVariant="courseList"
					data={courseData}
					webinarsOnly
					locale={locale}
				/>
			</PageSection>
		</GoogleReCaptchaProvider>
	);
};

const WrappedWebinarLibrary = ({ data, location }) => (
	<GLULayout locale={data.datoCmsGluWebinarsPage.locale}>
		<WebinarLibrary data={data} location={location} />
	</GLULayout>
);

export default WrappedWebinarLibrary;

export const query = graphql`
	query gluWebinarLibrary($locale: String!) {
		datoCmsGluWebinarsPage(locale: { eq: $locale }) {
			noIndex
			noFollow
			seoMeta {
				title
				description
				image {
					url
				}
				twitterCard
			}
			liveWebinarSessions {
				highlightedLiveWebinar {
					title
					dateAndTime
					slug
				}
				image {
					gatsbyImageData(placeholder: DOMINANT_COLOR)
					alt
				}
				upcomingLiveWebinars {
					title
					dateAndTime
					slug
				}
			}
			locale
		}
		allDatoCmsGluCourse(
			limit: 1
			filter: {
				isWebinarCatchUp: { eq: true }
				hideInOnDemandLibrary: { ne: true }
				locale: { eq: $locale }
			}
		) {
			totalCount
		}
	}
`;
